export * from './pagination-table.component';